import { NavLink } from "react-router-dom"
import Faq from "./faq"
import { useEffect } from "react"
import { CONTACT_CONFIG } from '../config/contact'

export default function Reimbursement() {
    // Utilisation des variables de configuration centralisées
    const contactInfo = CONTACT_CONFIG;
    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    return (
        <>
            {/* Header Section */}
            <section className="bg-gradient-to-r from-[#0a1a5f] via-[#002f9c] to-[#0d47ff] text-white py-8 relative overflow-hidden">
                {/* Background Decoration */}
                <div className="absolute top-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full -translate-y-48 translate-x-48"></div>
                <div className="absolute bottom-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full translate-y-32 -translate-x-32"></div>
                
                <div className="h-[25vh]"></div>
                <div className="main-content relative z-10">        
                    {/* Main Title */}
                    <div className="text-center">
                        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-3">
                            Política de 
                            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400">
                                Reembolso
                            </span>
                        </h1>
                    </div>
                    {/* Navigation Breadcrumbs */}
                    <div className="text-center mb-4">
                        <span className="text-sm">
                            <NavLink 
                                to="/" 
                                className="transition-all duration-500 hover:text-yellow-400"
                                onClick={scrollToTop}
                            >
                                Inicio
                            </NavLink> / <span className="text-gray-300">Política de Reembolso</span>
                        </span>
                    </div>
                </div>
            </section>

            {/* Content Section */}
            <section className="py-5 sm:py-12 relative overflow-hidden">
                {/* Background Pattern */}
                <div className="absolute inset-0 opacity-20">
                    <div className="h-64 w-full" style={{
                        backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                        backgroundSize: '20px 20px'
                    }}></div>
                </div>
                
                <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative z-10">
                    <div className="space-y-8">
                        {/* Section 1 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#0a1a5f] to-[#002f9c] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">1</span>
                                </div>
                                Direito ao reembolso
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                                 No TVPortugal4k, comprometemo-nos a garantir a tua satisfação. Por isso, oferecemos uma política de reembolso de 15 dias para todos os nossos utilizadores. Se, por qualquer motivo, não estiveres satisfeito com os nossos serviços, podes solicitar um reembolso dentro de 15 dias após a tua compra.
                            </p>
                        </div>

                        {/* Section 2 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#002f9c] to-[#0d47ff] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">2</span>
                                </div>
                                Condições de reembolso
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-4">
                            Para seres elegível para um reembolso, devem ser cumpridas as seguintes condições:
                            </p>
                            <ul className="list-disc list-inside space-y-2 text-sm sm:text-base text-gray-600">
                                <li>O pedido deve ser feito dentro de 15 dias após a data da compra.</li>
                                <li>Deves fornecer uma prova de compra válida, como o teu recibo ou e-mail de confirmação.</li>
                                <li>Os reembolsos não estão disponíveis se já tiveres utilizado mais de 50% do teu período de subscrição.</li>
                            </ul>
                        </div>

                        {/* Section 3 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#0d47ff] to-[#1d4ed8] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">3</span>
                                </div>
                                Processo de solicitação
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-4">
                            Para solicitar um reembolso, segue estes passos:
                            </p>
                            <ol className="list-inside list-decimal space-y-2 text-sm sm:text-base text-gray-600">
                                <li>Contacta a nossa equipa de suporte através do WhatsApp ou e-mail</li>
                                <li>Fornece o teu número de pedido e o motivo do reembolso.</li>
                                <li>Anexa a prova de compra (recibo ou e-mail de confirmação).</li>
                            </ol>
                        </div>

                        {/* Section 4 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#1d4ed8] to-[#3b82f6] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">4</span>
                                </div>
                                Método de reembolso
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                            Se o teu pedido de reembolso for aprovado, o valor será devolvido através do mesmo método de pagamento que utilizaste na tua compra. O tempo de processamento pode variar dependendo do teu fornecedor de pagamentos.
                            </p>
                        </div>

                        {/* Section 5 */}
                        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-blue-900 flex items-center">
                                <div className="w-8 h-8 bg-gradient-to-br from-[#3b82f6] to-[#60a5fa] rounded-full flex items-center justify-center mr-3">
                                    <span className="text-white font-bold text-sm">5</span>
                                </div>
                                Contacta-nos
                            </h2>
                            <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-4">
                            Para qualquer questão sobre esta política de reembolso ou para exercer os teus direitos, podes contactar-nos através de:
                            </p>
                            <ul className="list-disc list-inside space-y-2 text-sm sm:text-base text-gray-600">
                                <li>Email : {contactInfo.email}</li>
                                <li>
                                    WhatsApp :{" "}
                                    <a 
                                        href={contactInfo.whatsappUrl} 
                                        target="_blank" 
                                        rel="noopener noreferrer"   
                                        className="text-blue-600 underline hover:text-blue-800 transition-colors duration-300"
                                    >
                                        Clica aqui para nos contactar
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Conclusion */}
                        <div className="bg-gradient-to-r from-[#0a1a5f] to-[#002f9c] rounded-2xl p-6 sm:p-8 text-white shadow-xl">
                            <div className="text-center">
                                <h3 className="text-lg sm:text-xl font-bold mb-4">
                                Obrigado por escolher {contactInfo.companyName}
                                </h3>
                                <p className="text-sm sm:text-base leading-relaxed opacity-90">
                                Temos orgulho em garantir a tua privacidade e oferecer-te um serviço de alta qualidade sem comprometer a tua segurança ou o teu anonimato
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <Faq/>
            </section>
            
        </>
    )
}
